export default {
  GET_ITEMS(state) {
    return state.departements
  },

}
